import { Icon, Popover } from '@blueprintjs/core'

import * as classnames from 'classnames/bind'
import * as firebase from 'firebase'
import * as moment from 'moment'
import * as R from 'ramda'
import * as React from 'react'

import { connect } from 'react-redux'
import MediaQuery from 'react-responsive'
import { Link } from 'react-router-dom'
import 'react-sortable-tree/style.css'
import Avatar from '../../components/Avatar'
import buttonStyles from '../../components/Button/button.scss'

import { dispatch, RootState, select, store } from '../../store'
import { getLectureStatus, LectureStatus } from '../../utils'
import launchStyles from './launch-panel.scss'

const cx = classnames.bind({ ...launchStyles, ...buttonStyles })
const stepCheck = [
  {
    key: `title`,
    label: `講座名稱`,
    value: false
  },
  {
    key: `speakerInfo`,
    label: `講師資訊`,
    value: true
  },
  {
    key: `description`,
    label: `講座簡介`,
    value: false
  },
  {
    key: `missions`,
    label: `獲得觀點`,
    value: false
  },
  {
    key: `estimatedFormGroup`,
    label: `講座內容`,
    value: false
  },
  {
    key: `units`,
    label: `試聽講座`,
    value: false
  },
  {
    key: `requirements`,
    label: `講座需求`,
    value: false
  },
  {
    key: `targetAudiences`,
    label: `誰適合參與`,
    value: false
  }
]
interface IProps extends ReturnType<typeof mapState> {
  lectureId: string
  isSpeaker: boolean
  isParticipant: boolean
  isContent?: boolean
  onActive?: () => void
  onhandleContent?: () => void
  onhandleEdit?: () => void
  handleMainActive?: () => void
  mobileLectureContent?: () => void
  isEdit: boolean
}
class LecturePanel extends React.Component<IProps> {
  public state = {
    showChapterEdit: false,
    showStatusTag: LectureStatus.Unknown
  }
  public panelCondition = () => {
    const rootState = store.getState()
    const { lectureId } = this.props
    const lecture = select.lectures.getById(rootState, lectureId)
    const participantIds = select.participants.getByLectureId(
      rootState,
      lectureId
    )
    if (lecture) {
      const { startedAt } = lecture
      const currentTime = firebase.firestore.Timestamp.now().seconds
      const startedTime = startedAt.seconds
      if (participantIds) {
        if (participantIds.find(p => p === 'this_id')) {
          return currentTime < startedTime
            ? `預購中_Join`
            : currentTime > startedTime + 30
            ? `已完成_Join`
            : `熱賣中_Join`
        } else {
          return currentTime < startedTime
            ? `預購中_notJoin`
            : currentTime > startedTime + 30
            ? `已完成_notJoin`
            : `熱賣中_notJoin`
        }
      }
    }
    return `預購中_notJoin`
  }
  public onLectureDescriptionChange = (description: string) => {
    const { lectureId } = this.props
    dispatch.lectures.updateLecture({
      lectureId,
      updated: { description }
    })
  }
  public onChapterEditToggle = () => {
    this.setState({ showChapterEdit: !this.state.showChapterEdit })
  }
  public componentDidMount = () => {
    const rootState = store.getState()
    const { lectureId } = this.props
    const lecture = select.lectures.getById(rootState, lectureId)
    const statusTag = getLectureStatus(lecture)
    this.setState({ showStatusTag: statusTag })
  }

  public componentWillReceiveProps = (nextProps: IProps) => {
    const rootState = store.getState()
    const lectureId: string = nextProps.lectureId
    const lecture = select.lectures.getById(rootState, lectureId)

    const checkStepList = [
      'title',
      // 'speakerInfo',
      'missions',
      'description',
      'units',
      'targetAudiences',
      'requirements',
      'estimatedFormGroup'
    ]
    if (lecture !== null) {
      checkStepList.forEach(key => {
        const idx = stepCheck.findIndex(s => s.key === key)
        if (key !== `estimatedFormGroup`) {
          stepCheck[idx].value = !R.isEmpty(lecture[key])
        } else {
          // tslint:disable: no-string-literal
          const estimatedFormGroupValue =
            !R.isEmpty(lecture['estimatedDuration']) &&
            !R.isEmpty(lecture['listPrice']) &&
            !R.isEmpty(lecture['earlyPrice'])
          stepCheck[idx].value = estimatedFormGroupValue
        }
      })
    }
  }
  public handleisEdit = () => {
    if (this.props.onhandleEdit) {
      this.props.onhandleEdit()
    }
  }

  public render() {
    const { isEdit } = this.props
    return (
      <div className={cx('lecture-panel')}>
        {this.renderMemberBlock()}
        {this.renderJoinBlock()}
        {isEdit ? this.renderStepCheck() : this.renderBuyInfo()}
      </div>
    )
  }
  public renderMemberBlock = () => {
    const { isEdit } = this.props
    const rootState = store.getState()
    const { lectureId } = this.props
    const lecture = select.lectures.getById(rootState, lectureId)
    const statusTag = getLectureStatus(lecture)
    const participantIds = select.participants.getByLectureId(
      rootState,
      lectureId
    )
    const showParticipantIdsLimit = 5
    const speakers = lecture
      ? lecture.speakerIds.map(speakerId =>
          select.users.getById(rootState, speakerId)
        )
      : []
    return (
      <div className={cx('lecture-panel__memberContainer')}>
        {speakers.map((speaker, idx) => (
          <div key={idx} className={cx('lecture-panel__mentor-info')}>
            <Avatar
              className={cx('avatar')}
              userId={lecture ? lecture.speakerIds[idx] : undefined}
            />
            <div className={cx('text')}>
              <h4 className={cx('name')}>
                {speaker ? speaker.fullName : 'N/A'}
              </h4>
              <h5 className={cx('title')}>{speaker ? speaker.title : 'N/A'}</h5>
            </div>
          </div>
        ))}
        {isEdit ? null : (
          <div
            className={cx('item', 'lecture-panel__status-tag', {
              'lecture-panel__status-tag-fundraising':
                this.state.showStatusTag === LectureStatus.Fundraising,
              'lecture-panel__status-tag-success':
                this.state.showStatusTag === LectureStatus.Success,
              'lecture-panel__status-tag-processing':
                this.state.showStatusTag === LectureStatus.Processing,
              'lecture-panel__status-tag-finish':
                this.state.showStatusTag === LectureStatus.Finish
            })}
          >
            {statusTag}
          </div>
        )}
        {isEdit ? null : (
          <div className={cx('lecture-panel__participants')}>
            <ul className={cx('group')}>
              {participantIds
                ? participantIds
                    .slice(0, showParticipantIdsLimit)
                    .map(participantId => {
                      return (
                        <li
                          key={participantId}
                          className={cx('item', 'lecture-panel__avatar')}
                        >
                          <Avatar
                            className={cx('avatar')}
                            userId={participantId}
                          />
                        </li>
                      )
                    })
                : null}
            </ul>
            <p className={cx('amount')}>
              <span>{participantIds ? participantIds.length : 'N/A'}</span>
              <span>人參加</span>
            </p>
          </div>
        )}
      </div>
    )
  }

  public renderJoinBlock = () => {
    const rootState = store.getState()
    const { lectureId, stats } = this.props
    const lecture = select.lectures.getById(rootState, lectureId)
    let isLectureStarted = false
    if (lecture) {
      isLectureStarted =
        moment.unix(lecture.startedAt.seconds).diff(moment()) < 0
    }
    return (
      <div className={cx('lecture-panel__join')}>
        {isLectureStarted ? (
          <React.Fragment>
            <div className={cx('board')}>
              <div className={cx('board__item')}>
                <p className={cx('amount')}>
                  {stats[lectureId]
                    ? (
                        R.sum(
                          stats[lectureId].materialMetas.map(meta =>
                            meta.metadata.duration
                              ? parseFloat(meta.metadata.duration)
                              : 0
                          )
                        ) / 60
                      ).toFixed(0)
                    : '---'}
                  {/* {stats[lectureId] ? (R.sum(stats[lectureId].materialMetas.map(meta => meta.metadata.duration ? parseFloat(meta.metadata.duration) : 0)) / 60).toFixed(0) : '---'} */}
                </p>
                <p className={'para'}>分鐘</p>
              </div>
              <div className={cx('board__item')}>
                <p className={cx('amount')}>
                  {stats[lectureId] ? stats[lectureId].replyIds.length : '---'}
                </p>
                <p className={'para'}>討論</p>
              </div>
              <div className={cx('board__item')}>
                <p className={cx('amount')}>
                  {stats[lectureId]
                    ? stats[lectureId].materialMetas.length
                    : '---'}
                </p>
                <p className={'para'}>教材</p>
              </div>
            </div>
          </React.Fragment>
        ) : (
          <React.Fragment>
            <div className={cx('board')}>
              <div className={cx('board__item')}>
                <p className={cx('amount')}>
                  {lecture ? lecture.estimatedDuration : '---'}
                </p>
                <p className={'para'}>預估分鐘</p>
              </div>
              <div className={cx('board__item')}>
                <p className={cx('amount')}>
                  {lecture ? lecture.listPrice : '---'}
                </p>
                <p className={'para'}>售價 NT$</p>
              </div>
            </div>
          </React.Fragment>
        )}
      </div>
    )
  }
  public nextStep = () => {
    if (R.find(R.propEq('value', false), stepCheck)) {
      return false
    }
    this.handleisEdit()
    return true
  }
  public renderStepCheck = () => {
    const { isEdit, lectureId } = this.props
    return (
      <div>
        <div className={cx('lecture-panel__stepCheckContainer')}>
          <ul>
            {stepCheck.map((item, id) => (
              <li key={id} className={cx({ active: item.value })}>
                <div>
                  <Icon icon="tick" />
                </div>
                <h4>{item.label}</h4>
              </li>
            ))}
          </ul>
        </div>
        {isEdit ? (
          <Link
            to={`/lectures/${lectureId}`}
            className={cx(
              'btn',
              'btn--primary',
              'btn--line',
              'btn--fluid',
              'btn--lg'
            )}
          >
            檢視講座
          </Link>
        ) : (
          <div
            className={cx('btn', 'btn--primary', 'btn--fluid', 'btn--lg')}
            onClick={this.handleisEdit}
          >
            返回編輯
          </div>
        )}
      </div>
    )
  }

  public mobileHandleActive = () => {
    if (this.props.handleMainActive) {
      this.props.handleMainActive()
    }
    if (this.props.onhandleContent) {
      this.props.onhandleContent()
    }
    if (this.props.mobileLectureContent) {
      this.props.mobileLectureContent()
    }
  }
  public popoverContent = () => {
    return (
      <div className={cx('lecture-panel__popover-content')}>
        <ul>
          <li>
            <h3>
              <div>
                <Icon icon="tick" iconSize={10} />
              </div>
              保證回覆
            </h3>
            <p>
              講者於「討論互動期」內保證回覆你所提出的問題，歡迎踴躍參與互動～
            </p>
          </li>
          <li>
            <h3>
              <div>
                <Icon icon="tick" iconSize={10} />
              </div>
              保存重聽
            </h3>
            <p>Qraft將保存你所參與的內容，讓你隨時瀏覽重聽。</p>
          </li>
        </ul>
      </div>
    )
  }
  public renderBuyInfo = () => {
    const rootState = store.getState()
    const { lectureId, isSpeaker, isParticipant, isContent } = this.props
    const lecture = select.lectures.getById(rootState, lectureId)
    const lectureStatus = getLectureStatus(lecture)
    const endedAt = lecture
      ? moment.unix(lecture.endedAt.seconds).format('YYYY/MM/DD')
      : `---`
    const startedAt = lecture
      ? moment.unix(lecture.startedAt.seconds).format('YYYY/MM/DD')
      : `---`
    return (
      <div className={cx('lecture-panel__buyInfoContainer')}>
        <Popover
          popoverClassName={cx('lecture-panel__duration-popover')}
          position={'top'}
          enforceFocus={false}
          isOpen={undefined}
        >
          <div className={cx('lecture-panel__duration')}>
            <h4 className={cx('lecture-panel__duration-text')}>講座進行期間</h4>
            <h4 className={cx('lecture-panel__duration-title')}>
              {startedAt} ~ {endedAt}
            </h4>
            <ul className={cx('lecture-panel__duration-tips')}>
              <li>
                <div>
                  <Icon icon="tick" iconSize={10} />
                </div>
                保證回覆
              </li>
              <li>
                <div>
                  <Icon icon="tick" iconSize={10} />
                </div>
                保存重聽
              </li>
            </ul>
          </div>
          {this.popoverContent()}
        </Popover>

        <MediaQuery query="(min-width: 991px)">
          <Link
            to={`/lectures/${lectureId}/content`}
            className={cx(
              'btn',
              'btn--primary',
              'btn--line',
              'btn--fluid',
              'btn--lg'
            )}
          >
            {lecture && new Date() >= lecture.startedAt.toDate()
              ? isSpeaker || isParticipant
                ? `進入討論`
                : `進入試聽並討論`
              : `進入試聽`}
          </Link>
          {isSpeaker || isParticipant ? null : (
            <Link
              to={`/payment?lectureId=${lectureId}`}
              className={cx('btn', 'btn--fluid', 'btn--primary', 'btn--lg')}
            >
              {lecture
                ? lectureStatus === LectureStatus.Fundraising
                  ? `NT$${lecture.earlyPrice} 立即參與`
                  : `NT$${lecture.listPrice} 立即參與`
                : 'N/A'}
            </Link>
          )}

          {/* speaker btn */}
          {isSpeaker ? (
            <React.Fragment>
              <Link
                to={`/lectures/${lectureId}/edit`}
                className={cx(
                  'btn',
                  'btn--primary',
                  'btn--line',
                  'btn--fluid',
                  'btn--lg'
                )}
              >
                編輯講座資訊
              </Link>
              {isContent ? (
                <button
                  className={cx(
                    'btn',
                    'btn--primary',
                    'btn--line',
                    'btn--fluid',
                    'btn--lg'
                  )}
                  onClick={this.props.onhandleContent}
                >
                  檢視講座簡介
                </button>
              ) : (
                <button
                  className={cx(
                    'btn',
                    'btn--primary',
                    'btn--line',
                    'btn--fluid',
                    'btn--lg'
                  )}
                  onClick={this.props.onhandleContent}
                >
                  編輯觀點內容
                </button>
              )}
            </React.Fragment>
          ) : null}
        </MediaQuery>

        <MediaQuery query="(max-width: 991px)">
          <div className={cx('mobile-panel')}>
            <Link
              to={`/lectures/${lectureId}/content`}
              className={cx(
                'btn',
                'btn--fluid',
                'btn--primary',
                'btn--line',
                'btn--lg',
                'btn-pay--before'
              )}
            >
              {isSpeaker || isParticipant ? '進入討論' : '試聽討論'}
            </Link>
            {!(isSpeaker || isParticipant) ? (
              <Link
                to={`/payment?lectureId=${lectureId}`}
                className={cx(
                  'btn',
                  'btn--fluid',
                  'btn--primary',
                  'btn--lg',
                  'btn-pay--before'
                )}
              >
                {lecture
                  ? lectureStatus === LectureStatus.Fundraising
                    ? `NT$${lecture.earlyPrice} 立即參與`
                    : `NT$${lecture.listPrice} 立即參與`
                  : 'N/A'}
              </Link>
            ) : null}
          </div>
        </MediaQuery>
      </div>
    )
  }
}

const mapState = ({
  auth,
  lectures,
  recommends,
  users,
  participants,
  stats
}: RootState) => ({
  auth,
  lectures,
  recommends,
  users,
  participants,
  stats
})

export default connect(mapState)(LecturePanel)



// WEBPACK FOOTER //
// ./src/pages/LecturePage/launch-panel.tsx